import sliceNames from '../constants/sliceNames';

export const END = 'none/end';
export const VALIDATE_CLAIM_DATA = 'none/validateClaimData';

export const SET_VEHICLE_LINK_LIST = `${sliceNames.claimSlice}/setVehicleLinkList`;
export const CLEAR_VEHICLE_LINK_LIST = `${sliceNames.claimSlice}/clearVehicleLinkList`;
export const SET_CLAIM_INFO_LINK_LIST = `${sliceNames.claimSlice}/setClaimInfoLinkList`;
export const CLEAR_CLAIM_INFO_LINK_LIST = `${sliceNames.claimSlice}/clearClaimInfoLinkList`;

export const VALIDATE_REGEX = `${sliceNames.appStateSlice}/validateRegex`;
export const SET_ERROR_MESSAGE = `${sliceNames.appStateSlice}/setErrorMessage`;
export const SET_LOADING_MODAL_FLAG = `${sliceNames.appStateSlice}/setLoadingModalFlag`;
